export const Performance = () => {
  const handleLoad = (event: React.SyntheticEvent<HTMLLinkElement>) => {
    const link = event.currentTarget;
    link.media = 'all';
  };

  return (
    <>
      {/* DNS Prefetch and Preconnect */}
      <link rel="dns-prefetch" href="https://maps.googleapis.com" />
      <link rel="preconnect" href="https://maps.googleapis.com" crossOrigin="anonymous" />
      
      {/* Preload critical fonts */}
      <link rel="preload" href="/fonts/BigJohnPro-Regular.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      
      {/* Defer non-critical CSS */}
      <link rel="stylesheet" href="https://fonts.googleapis.com/css" media="print" onLoad={handleLoad} />
      
      {/* PWA Meta Tags */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#FF4B2B" />
      
      {/* Analytics - Load asynchronously */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-MKZ7Q7BBG1"></script>
    </>
  );
};